<template>
  <div>
    <Topbar :switchboardIdentity="switchboardIdentity"></Topbar>
    <el-dialog
      title="温馨提示"
      v-if="dialogAccepte"
      :visible.sync="dialogAccepte"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <span class="yellow-txt">[{{ switchboardItem.switchboard_name }}]</span
        >欢迎您的加入！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogAccepte = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="温馨提示"
      v-if="dialogRefuse"
      :visible.sync="dialogRefuse"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        您已经拒绝<span class="yellow-txt"
          >[{{ switchboardItem.switchboard_name }}]</span
        >！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogRefuse = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="温馨提示"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        公司<span class="green-txt"
          >[{{ switchboardItem.switchboard_name }}]</span
        >给您分配了：
      </div>
      <div>
        编号：<span class="yellow-txt">{{ switchboardItem.name }}</span>
      </div>
      <div>
        姓名：<span class="yellow-txt">{{ switchboardItem.alias }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toHandleSwitchboard(false)">放弃这次机会</el-button>
        <el-button type="primary" @click="toHandleSwitchboard(true)"
          >同意</el-button
        >
      </span>
    </el-dialog>

    <div id="header" class="header clearfix">
      <div class="logo">
        <a href="/"><img src="../assets/logo-1.png" /></a>
      </div>
      <div id="cssmenu" class="nav" style="opacity: 1">
        <ul class="clearfix">
          <li :class="{ active: current == '我的' }">
            <a @click="toPath(3)" id="num02">我的</a>
          </li>
          <li
            :class="{ active: current == item.name }"
            v-for="(item, index) in listMenu"
            :key="index"
          >
            <a @click="toPath(1, item.url, item.domain, item)">{{
              item.name
            }}</a>
            <ul v-if="item.children && item.children.length > 0">
              <li v-for="(ele, i) in item.children" :key="i">
                <a @click="toPath(1, ele.url, ele.domain, item)">{{
                  ele.name
                }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="head-r clearfix">
        <a id="tabRole" @click="getList" class="tabRole l">
          当前编号：<span class="green-txt ftmiddle">{{
            switchboardIdentity.switchboard_identity_name
          }}</span
          ><span
            class="green-txt ftmiddle"
            v-if="
              switchboardIdentity.switchboard_identity_alias &&
              switchboardIdentity.switchboard_identity_type != 2
            "
            >/{{ switchboardIdentity.switchboard_identity_alias }}</span
          >
          ∨</a
        >
        <a
          href="/common/organizationstructure/skip/logout"
          class="yellow r reviewDetail"
          >退出</a
        >
      </div>
      <div class="i_personal" style="max-height: 752px; display: none">
        <div class="identity">
          <ul class="identityTitle">
            <li
              class="item"
              @click="tabSwitch(1)"
              v-if="identity.person.length"
              :class="currentIdentity == 1 ? 'active' : ''"
            >
              个人身份
            </li>
            <li
              class="item"
              @click="tabSwitch(2)"
              v-if="identity.company.length"
              :class="currentIdentity == 2 ? 'active' : ''"
            >
              公司身份
            </li>
            <li
              class="item"
              @click="tabSwitch(3)"
              v-if="identity.othrIdentity.length"
              :class="currentIdentity == 3 ? 'active' : ''"
            >
              职位身份
            </li>
          </ul>
          <div class="identityBody">
            <div
              class="bl"
              :class="key"
              v-for="(item, key, index) in identity"
              :key="index"
            >
              <ul
                class="ul"
                v-if="item && item.length && currentIdentity == item[0].type"
              >
                <li
                  class="item"
                  :class="e.current ? 'active' : ''"
                  v-for="(e, i) in item"
                  :key="i"
                  @click="switchIdentity(e)"
                >
                  <a class="a" href="javascript:void(0)">
                    <span class="icon"></span>
                    <template v-if="e.type == 1">
                      {{ e.name }}
                    </template>
                    <template v-else-if="e.type == 2">
                      {{ e.name }}
                    </template>
                    <template v-else>
                      <span class="icon waidan" v-if="!e.mainstay"></span>
                      <span class="green-txt">【{{ e.switchboard_name }}】</span
                      >{{ e.name
                      }}<template v-if="e.alias">/{{ e.alias }}</template>
                    </template>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- <div class="list geren">
					<h4 class="ftSmall gray1">个人身份</h4>
					<ul>
						<li :class="className(item)" v-for="(item, index) in person" :key="index">
							<a @click="switchIdentity(item)" href="javascript:void(0)">
								<span class="gray3 ftlarge l">{{item.name}}</span>
							</a>
							<a v-if="item.current" class="r" href="/">用户信息</a>
						</li>
					</ul>
				</div>
				<div class="list gongsi">
					<h4 class="ftSmall gray1">我的公司</h4>
					<ul>
						<li :class="className(item)" v-for="(item, index) in company" :key="index">
							<a @click="switchIdentity(item)" href="javascript:void(0)">
								<span class="gray3 ftlarge l">{{item.name}}</span>
							</a>
						</li>
					</ul>
				</div>
				<div class="list qita">
					<h4 class="ftSmall gray1">其他编号</h4>
					<ul>
						<li @click="switchIdentity(item)" :class="className(item)" v-for="(item, index) in othrIdentity" :key="index">
							<a href="javascript:void(0);">
								<span class="gray3 ftlarge l">
									<span class="green-txt ftlarge">【{{item.switchboard_name}}】</span>
									{{item.name}}/{{item.alias}}
								</span>
							</a>
						</li>
					</ul>
				</div>
				<div class="list zhongzhi">
					<ul></ul>
				</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import apiData from "@/config/api";
import http from "@/config/httpConfig";
import Topbar from "@/components/Topbar.vue";
$(function () {
  var nav = $(".header .nav");
  nav.animate(
    {
      opacity: 1,
    },
    0
  );
  var navLi = $(".header .nav").children("ul").children("li");

  function head() {
    var rWidth = $(".header .head-r").width();
    //console.log(rWidth)
    var navWidth = $(document).width() - 201 - rWidth;
    navLi.css({
      width: navWidth / navLi.length,
    });
  }
  //切换身份
  function hasScrollbar() {
    if (
      document.body.scrollHeight >
      (window.innerHeight || document.documentElement.clientHeight)
    ) {
      //有滚动条
      //console.log("有滚动条")
      $(".header .i_personal").css({
        "max-height": 10000,
      });
    } else {
      //console.log("无滚动条")
      var navHeight = $(window).height() - 90;
      $(".header .i_personal").css({
        "max-height": navHeight,
      });
    }
  }
  // head()
  hasScrollbar();
  var resizeTimer = null;
  $(window).resize(function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // head()
      hasScrollbar();
    }, 10);
  });
});
export default {
  name: "Nav",
  props: {
    switchboardIdentity: {
      type: Object,
      default: function () {
				let switchboardIdentity = localStorage.getItem("switchboardIdentity");
				// console.log(switchboardIdentity)
				if (switchboardIdentity) {
					// console.log(JSON.parse(switchboardIdentity))
          switchboardIdentity = JSON.parse(switchboardIdentity);
        } else {
          switchboardIdentity = {
            login: "",
            switchboard_name: "",
            switchboard_identity_type: "",
            switchboard_identity_name: "",
            switchboard_identity_alias: "",
						name: "",
          };
        }

        return switchboardIdentity;

        // return {
        // 	"login":"",
        // 	"switchboard_name":"",
        // 	"switchboard_identity_type":"",
        // 	"switchboard_identity_name":"",
        // 	"switchboard_identity_alias":"",
        // 	"name":"",
        // }
      },
    },
    current: {
      type: String,
      default: "我的", //定义参数默认值
    },
  },
  components: {
    Topbar,
  },
  data() {
    return {
      currentIdentity: 1, //当前身份tab
      identity: {
        person: [],
        company: [],
        othrIdentity: [],
      }, //身份对象
      switchboardItem: null,
      dialogVisible: false,
      dialogAccepte: false,
      dialogRefuse: false,
			listMenu: null,
    };
  },
  mounted() {
    if (!this.$route.query.switchboard_identity_id) {
      this.getListMenu()
    }
    document.addEventListener("click", function (e) {
      let flag = $(e.target).parents().hasClass("i_personal");
      if ($(e.target).parents().hasClass("i_personal")) {
        return;
      }
      if (
        e.target.className != "i_personal" &&
        e.target.className != "tabRole l" &&
        e.target.className != "green-txt ftmiddle"
      ) {
        $(".i_personal").hide();
      }
    });
  },
  methods: {
    toHandleSwitchboard(type) {
      let item = this.switchboardItem;
      let _this = this;
      let params = {
        id: this.switchboardItem.id,
      };
      _this.dialogVisible = false;
      if (type) {
        _this.dialogAccepte = true;
        http.get(apiData.switchboardAccepte, true, params, (res) => {
          console.log(res);
          // if(res && res.data && res.data.data && res.data.data.length){

          // }
        });
      } else {
        // http.get(apiData.switchboardRefuse, true, params, (res) => {
        // 	console.log(res)
        _this.dialogRefuse = true;
        // 	// if(res && res.data && res.data.data && res.data.data.length){

        // 	// }
        // })
      }
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
    jumpPage() {
      this.$router.push("/company/adminSystem").catch((err) => err);
    },
    adminMenu() {
      this.$router.push("/company/adminMenu").catch((err) => err);
    },
    dataDeal(treedata) {
      //treedata为原数组
      var parents = treedata.filter((value) => !value.parentId);
      var children = treedata.filter((value) => value.parentId !== 0);
      var translator = (parents, children) => {
        parents.forEach((parent) => {
          children.forEach((child, index) => {
            if (child.parentId == parent.id) {
              let temp = JSON.parse(JSON.stringify(children));
              temp.splice(index, 1);
              translator([child], temp);
              typeof parent.children !== "undefined"
                ? parent.children.push(child)
                : (parent.children = [child]);
            }
          });
        });
      };
      translator(parents, children);
      return parents;
    },
    getListMenu(type) {
      let _this = this;
      let roleId = this.roleId;
      let params = {
        roleId,
      };
      http.get(apiData.listMenu, true, params, (res) => {
        if (res && res.data && res.data.data && res.data.data.length) {
          let data = res.data.data;
          let result = _this.dataDeal(data);
          if (result && result.length) {
            _this.listMenu = result;
            // console.log('请求菜单',_this.listMenu)
            localStorage.setItem("listMenu", JSON.stringify(result));
          }
        }
      }, () => {}, false, false);
      // if (type) {
      
      // } else {
      //   let listMenu = localStorage.getItem("listMenu");
      //   if (listMenu) {
      //     listMenu = JSON.parse(listMenu);
      //     // console.log('菜单',listMenu)
      //     _this.listMenu = listMenu;
      //   } else {
      //     http.get(apiData.listMenu, true, params, (res) => {
      //       if (res && res.data && res.data.data && res.data.data.length) {
      //         let data = res.data.data;
      //         let result = _this.dataDeal(data);
      //         if (result && result.length) {
      //           _this.listMenu = result;
      //           localStorage.setItem("listMenu", JSON.stringify(result));
      //         }
      //       }
      //     });
      //   }
      // }
    },
    tabSwitch(type) {
      this.currentIdentity = type;
    },
    switchIdentity(item) {
      this.switchboardItem = item;
      if (item.status == 1) {
        //有消息，未同意
        this.dialogVisible = true;
      } else if (item.status == 2) {
        //已接受
        localStorage.setItem("listMenu", null)
        window.location.href =
          item.domain + "/?&switchboard_identity_id=" + item.id;
      }
    },
    toReturn() {
      // alert('当前系统暂未开放此功能，敬请期待！')
    },
    identityBodyClassName: function (params) {
      console.log(params);
      var className = "";
      if (params.type == "1") {
        //个人身份
        className = "person";
      } else if (params.type == "2") {
        //公司身份
        className = "company";
      } else if (params.type == "3") {
        //其他身份
        className = "othrIdentity";
      }
      return className;
    },
    className: function (item) {
      var className = "";
      className = item.status == 1 ? "info-box" : "";
      className = !item.mainstay ? "out " + className : className;
      className = item.current ? "active " + className : className;
      return className;
    },
    getList() {
      // return
      var _this = this;
      let params = {};
      if ($(".i_personal").css("display") != "none") {
        return;
      }
      http.get(apiData.switchboardAssignment, true, params, (res) => {
        console.log(res);
        if (res && res.data) {
          let data = res.data.data;
          $(".i_personal").show();
          _this.identity.person = [];
          _this.identity.company = [];
          _this.identity.othrIdentity = [];
          data.forEach(function (ele) {
            if (ele.current) {
              _this.currentIdentity = ele.type;
            }
            if (ele.type == 1) {
              _this.identity.person.push(ele);
            } else if (ele.type == 2) {
              _this.identity.company.push(ele);
            } else if (ele.type == 3) {
              _this.identity.othrIdentity.push(ele);
            }
          });
        }
      });
    },
    toPath(type, url, domain, item) {
      // 移除reportFormListState
      localStorage.removeItem("reportFormListState")
      // 移除expandedNodes
      localStorage.removeItem("expandedNodes")

      if (item && item.level == "02") {
        //刷新当前页面
        if (this.$router.currentRoute.fullPath == url) {
          location.reload() 
        } else {
          this.$router.push(url, () => {})
        }
      } else {
        if (type === 2) {
          //我的公司
          this.$router.push(`/company/${url}`).catch((err) => err);
        } else if (type == 1) {
          //domain
          let href = domain;
          if (url) {
            href = domain + url;
          }
          window.location.href = href;
        } else if (type == 3) {
          this.$router.push("/").catch((err) => err);
        } else if (type == 4) {
          this.$router.push("/company/webLog").catch((err) => err);
        } else if (type == 5) {
          this.$router.push("/company/calcSign").catch((err) => err);
        }
      }
    },
  },
};
</script>
<style lang="less">
.commonTopbar {
  line-height: 30px;
  height: 30px;
  padding: 0 10px;
}

.commonTopbar .bar_right .dropInfo ul li {
  float: none;
}

.commonTopbar p,
.commonTopbar span,
.commonTopbar a {
  margin: 0;
}

.commonTopbar .bar_left .download:before {
  display: inline-block;
  content: "";
  width: 11px;
  height: 20px;
  vertical-align: -5px;
  margin: 0 5px 0 20px;
  background: url(../images/watch/icon.png) no-repeat;
  background-position: -224px -62px;
}

.commonTopbar .bar_right {
  float: right;
  z-index: 303;
}

.commonTopbar .bar_right ul li {
  float: left;
}

.commonTopbar .bar_right a {
  cursor: pointer;
}

.commonTopbar .bar_right .message {
  position: relative;
  display: inline-block;
  width: 17px;
  height: 19px;
  vertical-align: -6px;
  margin-right: 10px;
  background: url(../images/watch/icon.png) no-repeat;
  background-position: -240px -38px;
}

.commonTopbar .bar_right .message i {
  position: absolute;
  right: -1px;
  top: 0;
  display: inline-block;
  width: 4px;
  height: 4px;
  background: red;
  border-radius: 50%;
}

.header {
  background: #f8f8f8;
  margin-bottom: 10px;
}

.header .logo {
  float: left;
  margin-left: 10px;
  margin-top: 9px;
}

.header .logo a {
  display: inline-block;
}

.header .nav {
  float: left;
  z-index: 302;
  opacity: 0;
}

.header .nav ul {
  margin: 0;
  display: flex;
}

.header .nav ul li {
  float: left;
  line-height: 60px;
}

.header .nav ul li .caiinfo {
  position: absolute;
  top: 12px;
  left: 50%;
  color: #fff;
  text-align: center;
  line-height: 17px;
  margin-left: 17px;
  height: 18px;
  background: #d5272b;
  min-width: 18px;
  padding: 0 5px;
  border-radius: 9px;
}

.header .nav ul li.active a {
  color: #55c4b8;
}

.header .nav ul li a {
  display: block;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: #666;
  transition: all 0.5s;
}

.header .nav ul li ul li a {
  width: 140px;
  padding: 0;
}

.header .nav ul li:hover a {
  color: #55c4b8;
}

.header .entry {
  float: right;
  font-size: 16px;
  color: #666;
  line-height: 42px;
  margin-right: 10px;
  margin-top: 9px;
}

.header .entry a {
  font-size: 16px;
  color: #55c4b8;
}

/*未登录header显示*/
.header .head-r {
  float: right;
  font-size: 16px;
  line-height: 30px;
  margin: 15px 10px;
}

.header .head-r .tabRole .green-txt {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
  vertical-align: -9px;
}

.header .head-r .tabRole {
  font-size: 16px;
}

.header .head-r a.yellow {
  width: 66px;
  margin-left: 7px;
  text-align: center;
  font-size: 14px;
  border-radius: 3px;
}

.header .head-r .tabRole:hover {
  color: #333;
  cursor: pointer;
}

.header .head-r ul li {
  float: left;
  margin-left: 10px;
}

a.btn-blue {
  display: block;
  font-size: 16px;
  color: #55c4b8;
  line-height: 28px;
  text-align: center;
  border: 1px solid #55c4b8;
  min-width: 94px;
  padding: 0 30px;
  height: 30px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 5px;
  transition: background 0.5s;
  -webkit-transition: background 0.5s;
  -moz-transition: background 0.5s;
  -ms-transition: background 0.5s;
}

.header .head-r ul li.on a {
  background: #55c4b8;
  color: #fff;
}

a.btn-blue:hover {
  background: #55c4b8;
  color: #fff;
}

#cssmenu {
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

#cssmenu ul,
#cssmenu ul li,
#cssmenu ul li a,
#bar_right,
#bar_right ul,
#bar_right ul li,
#bar_right ul li a {
  display: block;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

#bar_right {
  height: 30px;
}

#cssmenu > ul > li {
  flex: 1;
  float: left;
  padding: 0 20px;
}

#cssmenu.align-center > ul {
  font-size: 0;
  text-align: center;
}

#cssmenu.align-center > ul > li {
  display: inline-block;
  float: none;
}

#cssmenu.align-right > ul > li {
  float: right;
}

#cssmenu.align-right ul ul {
  text-align: right;
}

#cssmenu > ul > li > a {
  cursor: pointer;
  text-transform: uppercase;
  -webkit-transition: color 0.2s ease;
  -moz-transition: color 0.2s ease;
  -ms-transition: color 0.2s ease;
  -o-transition: color 0.2s ease;
  transition: color 0.2s ease;
}

#cssmenu ul ul,
#bar_right ul ul {
  position: absolute;
  left: -9999px;
  box-shadow: 0px 3px 15px #666;
}

#cssmenu li:hover > ul,
#bar_right li:hover > ul {
  cursor: pointer;
  left: 50%;
  margin-left: -70px;
}

#cssmenu.align-right li:hover > ul {
  right: 0;
}

#cssmenu.align-right ul ul ul {
  margin-left: 0;
  margin-right: 100%;
}

#cssmenu ul ul li,
#bar_right ul ul li,
.enterList li {
  height: 0;
  background: #fff;
  clear: both;
  -webkit-transition: height 0.2s ease;
  -moz-transition: height 0.2s ease;
  -ms-transition: height 0.2s ease;
  -o-transition: height 0.2s ease;
  transition: height 0.2s ease;
}

#cssmenu ul li:hover > ul > li,
#bar_right ul li:hover > ul > li,
.enterList li:hover {
  height: 32px;
}

#cssmenu ul ul li a,
#bar_right ul ul li a,
.enterList li a {
  width: 140px;
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  line-height: 32px;
  background: #fff;
  text-decoration: none;
  color: #666;
  -webkit-transition: color 0.2s ease;
  -moz-transition: color 0.2s ease;
  -ms-transition: color 0.2s ease;
  -o-transition: color 0.2s ease;
  transition: color 0.2s ease;
}

#cssmenu ul ul.func {
  width: 338px;
  min-width: 338px;
  padding: 10px;
  background: #fff;
}

#cssmenu li:hover > ul.func {
  left: -90px;
}

#cssmenu ul ul.func li:nth-child(7),
#cssmenu ul ul.func li:nth-child(8),
#cssmenu ul ul.func li:nth-child(9) {
  border-bottom: 1px solid #ccc;
}

#cssmenu ul ul.func li {
  float: left;
  clear: none;
  line-height: 30px;
}

#bar_right ul ul li a {
  width: 80px;
}

#bar_right ul ul.message_list li a,
#bar_right ul ul.message_list li a span {
  text-align: left;
  font-size: 14px;
  color: #666;
  width: 300px;
}

#bar_right ul ul.message_list li.yd a,
#bar_right ul ul.message_list li.yd a span {
  color: #999;
}

#bar_right ul ul.message_list li a {
  height: 32px;
  padding: 0 10px;
  border-bottom: 1px solid #eee;
}

#bar_right ul ul.message_list li a span {
  margin-right: 10px;
}

#bar_right ul ul.message_list li {
  border-top: 1px solid #eeeeee;
}

#bar_right ul ul.message_list li:hover a,
#bar_right ul ul.message_list li:hover a span,
#bar_right ul ul.message_list li a:hover {
  color: #666;
  background: #fff;
}

#bar_right ul ul.message_list,
#bar_right ul ul.user_info {
  left: auto;
  right: 0;
  background: #fff;
  height: 0;
  overflow: hidden;
}

#bar_right .message_list .title {
  border-bottom: 1px solid #ccc;
}

#bar_right .message_list .title span {
  float: left;
  font-size: 16px;
  color: #666;
  line-height: 36px;
  margin-left: 10px;
}

#bar_right .message_list .title a {
  float: right;
  font-size: 12px;
  color: #999;
  line-height: 36px;
  margin-right: 10px;
}

#bar_right .message_list a.all {
  display: inline-block;
  line-height: 36px;
  text-align: center;
  color: #666;
  width: 100%;
}

#bar_right ul .turn:hover .message_list {
  height: auto;
}

#bar_right ul .user_name_select:hover ul {
  height: auto;
}

#cssmenu ul ul li:hover > a,
#cssmenu ul ul li a:hover,
#bar_right ul ul li:hover > a,
#bar_right ul ul li a:hover,
.enterList li a:hover {
  color: #ffffff;
  background: #55c4b8;
}
/*个人信息*/
.i_personal {
  position: absolute;
  right: 0px;
  top: 75px;
  width: 600px;
  background: #fff;
  z-index: 1001;
  box-shadow: 0px 3px 10px #999;
  overflow-y: auto;
  display: none;
  .identity {
    margin: 30px;
    font-family: "Microsoft Yahei", "微软雅黑", arial;
    .identityTitle {
      display: flex;
      align-items: center;
      justify-items: center;
      .item {
        width: 180px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        color: #55c4b8;
        background: #fff;
        border: 1px solid #55c4b8;
        border-right: none;
        transition: all 0.5s;
        &:last-child {
          border-right: 1px solid #55c4b8;
        }
        &.active {
          color: #fff;
          background: #55c4b8;
          &:hover {
            color: #fff;
            background: #55c4b8;
            border: 1px solid #55c4b8;
          }
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
    .identityBody {
      padding: 20px 0;
      background: #f9f9f9;
      .bl {
        font-size: 20px;
        line-height: 34px;
        .ul {
          display: grid;
          min-height: 100px;
          overflow-x: auto;
          .item {
            padding: 0 10px;
            margin: 2px 0;
            height: 34px;
            transition: all 300ms;
            .a {
              position: relative;
              display: inline-block;
              padding-left: 30px;
              font-weight: bold;
              white-space: nowrap;
              .icon {
                position: absolute;
                top: 50%;
                left: 0;
                margin-top: -14px;
                height: 28px;
                width: 28px;
                background-size: 22px 22px;
                &.waidan {
                  position: static;
                  vertical-align: -6px;
                  display: inline-block;
                  background: url("../images/bianhao_shezhi.png") no-repeat
                    center center;
                  background-size: 22px 22px;
                }
              }
              &:hover {
                color: #000;
              }
            }
            &.active {
              background: #eee;
              transition: all 300ms;
            }
            &:hover {
              background: #eee;
              transition: all 300ms;
            }
          }
        }
        &.person {
          .icon {
            background: url("../images/bianhao_geren.png") no-repeat center
              center;
          }
        }
        &.company {
          .icon {
            background: url("../images/bianhao_gongsi.png") no-repeat center
              center;
          }
        }
        &.othrIdentity {
          .icon {
            background: url("../images/bianhao_zhiwei.png") no-repeat center
              center;
          }
        }
      }
    }
  }
}
.ftSmall {
  font-size: 14px;
}
.ftmiddle {
  font-size: 16px;
}
.ftlarge {
  font-size: 18px;
}
.gray1 {
  color: #999;
}
.gray2 {
  color: #666;
}
.green-txt {
  color: #55c4b8;
}
.el-dialog__body {
  font-size: 16px;
  font-weight: bold;
}
</style>